import { app } from '../../app.module'
app
  // 投稿内容(テーブル内)
  .directive('postTableBody', () => {
    return {
      restrict: 'EA',
      template: require('./post-table-body.pug')(),
    }
  })
